import React from 'react';

const Input = ({ type, value, onValueChange, placeholder, maxLength, disabled }) => {
	return (
		<div className="flex items-center gap-x-4 border border-gray3 bg-white rounded-md h-10 w-full px-2">
			<input
				type={type || "text"}
				className="flex-1 outline-none border-none bg-transparent text-sm w-full"
				placeholder={placeholder}
				value={value}
				onChange={e => onValueChange(e.target.value)}
				maxLength={maxLength}
				disabled={disabled}
			/>
		</div>
	);
}

export default Input;